/**
 * Specifies the File Manager internal ID's
 */
/** @hidden */
export var ITEM_VERTICAL_CENTER = 'e-ribbon-vertical-center';
/** @hidden */
export var EXPAND_COLLAPSE_ICON = 'e-icons e-drop-icon';
/** @hidden */
export var BACKSTAGE_CLOSE_ICON = 'e-icons e-arrow-left';
/** @hidden */
export var OVERFLOW_ICON = 'e-icons e-more-horizontal-1';
/** @hidden */
export var VERTICAL_DDB = 'e-vertical';
/** @hidden */
export var DISABLED_CSS = 'e-disabled';
/** @hidden */
export var RTL_CSS = 'e-rtl';
/** @hidden */
export var RIBBON_HOVER = 'e-ribbon-hover';
/** @hidden */
export var RIBBON_CONTROL = 'e-ribbon-control';
/** @hidden */
export var RIBBON_POPUP_CONTROL = 'e-ribbon-popup-control';
/** @hidden */
export var RIBBON_POPUP_OPEN = 'e-ribbon-open';
/** @hidden */
export var RIBBON_KEYTIP = 'e-ribbon-keytip';
/** @hidden */
export var SPACE = ' ';
/** @hidden */
export var HORIZONTAL_SCROLLBAR = 'e-hscroll-bar';
/** @hidden */
export var HIDE_CSS = 'e-ribbon-hide';
/** @hidden */
export var RIBBON_TAB = 'e-ribbon-tab';
/** @hidden */
export var RIBBON_CONTEXTUAL_TAB = 'e-ribbon-contextual-tab';
/** @hidden */
export var RIBBON_TAB_ACTIVE = 'e-ribbon-active';
/** @hidden */
export var RIBBON_TAB_ITEM = 'e-ribbon-tab-item';
/** @hidden */
export var RIBBON_COLLAPSE_BUTTON = 'e-ribbon-collapse-btn';
/** @hidden */
export var RIBBON_EXPAND_BUTTON = 'e-ribbon-expand-btn';
/** @hidden */
export var RIBBON_COLLAPSIBLE = 'e-ribbon-collapsible';
/** @hidden */
export var RIBBON_OVERALL_OF_BUTTON = 'e-ribbon-overall-of-btn';
/** @hidden */
export var RIBBON_GROUP_OF_BUTTON = 'e-ribbon-group-of-btn';
/** @hidden */
export var RIBBON_OVERFLOW_TARGET = 'e-ribbon-overflow-target';
/** @hidden */
export var RIBBON_OVERFLOW = 'e-ribbon-overflow';
/** @hidden */
export var TAB_CONTENT = 'e-content';
/** @hidden */
export var RIBBON_MINIMIZE = 'e-ribbon-minimize';
/** @hidden */
export var RIBBON_GROUP = 'e-ribbon-group';
/** @hidden */
export var RIBBON_SINGLE_BUTTON_SELECTION = 'e-ribbon-single-selection';
/** @hidden */
export var RIBBON_MULTIPLE_BUTTON_SELECTION = 'e-ribbon-multiple-selection';
/** @hidden */
export var RIBBON_GROUP_BUTTON = 'e-ribbon-group-button';
/** @hidden */
export var RIBBON_GROUP_BUTTON_OVERFLOW_POPUP = 'e-ribbon-group-button-overflow-popup';
/** @hidden */
export var RIBBON_GROUP_BUTTON_CONTENT = 'e-ribbon-group-button-content';
/** @hidden */
export var RIBBON_GROUP_CONTAINER = 'e-ribbon-group-container';
/** @hidden */
export var RIBBON_OF_TAB_CONTAINER = 'e-ribbon-of-tab';
/** @hidden */
export var RIBBON_OF_GROUP_CONTAINER = 'e-ribbon-of-group-container';
/** @hidden */
export var RIBBON_GROUP_CONTENT = 'e-ribbon-group-content';
/** @hidden */
export var RIBBON_GROUP_HEADER = 'e-ribbon-group-header';
/** @hidden */
export var RIBBON_OVERFLOW_HEADER = 'e-ribbon-overflow-header';
/** @hidden */
export var RIBBON_GROUP_OVERFLOW = 'e-ribbon-group-overflow';
/** @hidden */
export var RIBBON_GROUP_OVERFLOW_DDB = 'e-ribbon-group-overflow-ddb';
/** @hidden */
export var RIBBON_LAUNCHER = 'e-ribbon-launcher';
/** @hidden */
export var RIBBON_LAUNCHER_ICON_ELE = 'e-ribbon-launcher-icon';
/** @hidden */
export var RIBBON_LAUNCHER_ICON = 'e-icons e-launcher';
/** @hidden */
export var RIBBON_COLLECTION = 'e-ribbon-collection';
/** @hidden */
export var RIBBON_ITEM = 'e-ribbon-item';
/** @hidden */
export var RIBBON_ROW = 'e-ribbon-row';
/** @hidden */
export var RIBBON_COLUMN = 'e-ribbon-column';
/** @hidden */
export var RIBBON_LARGE_ITEM = 'e-ribbon-large-item';
/** @hidden */
export var RIBBON_MEDIUM_ITEM = 'e-ribbon-medium-item';
/** @hidden */
export var RIBBON_SMALL_ITEM = 'e-ribbon-small-item';
/** @hidden */
export var RIBBON_CONTENT_HEIGHT = 'e-ribbon-content-height';
/** @hidden */
export var DROPDOWNBUTTON = 'e-dropdown-btn';
/** @hidden */
export var DROPDOWNBUTTON_HIDE = 'e-caret-hide';
/** @hidden */
export var RIBBON_TEMPLATE = 'e-ribbon-template';
/** @hidden */
export var RIBBON_HELP_TEMPLATE = 'e-ribbon-help-template';
/** @hidden */
export var RIBBON_TOOLTIP = 'e-ribbon-tooltip';
/** @hidden */
export var RIBBON_TOOLTIP_TARGET = 'e-ribbon-tooltip-target';
/** @hidden */
export var RIBBON_TOOLTIP_TITLE = 'e-ribbon-tooltip-title';
/** @hidden */
export var RIBBON_TOOLTIP_CONTENT = 'e-ribbon-tooltip-content';
/** @hidden */
export var RIBBON_TOOLTIP_ICON = 'e-ribbon-tooltip-icon';
/** @hidden */
export var RIBBON_TOOLTIP_CONTAINER = 'e-ribbon-tooltip-container';
/** @hidden */
export var RIBBON_TEXT_CONTAINER = 'e-ribbon-text-container';
/** @hidden */
export var RIBBON_SIMPLIFIED_MODE = 'e-ribbon-simplified-mode';
/** @hidden */
export var RIBBON_BACKSTAGE_POPUP = 'e-ribbon-backstage-popup';
/** @hidden */
export var RIBBON_BACKSTAGE_OPEN = 'e-ribbon-backstage-open';
/** @hidden */
export var RIBBON_BACKSTAGE_CONTENT = 'e-ribbon-backstage-content';
/** @hidden */
export var RIBBON_SELECTED_CONTENT = 'e-ribbon-selected-content';
/** @hidden */
export var RIBBON_BACKSTAGE = 'e-ribbon-backstage';
/** @hidden */
export var RIBBON_BACKSTAGE_MENU = 'e-ribbon-backstage-menu';
/** @hidden */
export var RIBBON_BACKSTAGE_TEMPLATE = 'e-ribbon-backstage-template';
/** @hidden */
export var RIBBON_BACKSTAGE_MENU_WRAPPER = 'e-ribbon-backstage-wrapper';
/** @hidden */
export var RIBBON_BACKSTAGE_ITEMS_WRAPPER = 'e-ribbon-backstage-items-wrapper';
/** @hidden */
export var RIBBON_BACKSTAGE_TEXT_MENU = 'e-blankicon';
/** @hidden */
export var TAB_ID = '_tab';
/** @hidden */
export var GROUP_ID = '_group';
/** @hidden */
export var COLLECTION_ID = '_collection';
/** @hidden */
export var ITEM_ID = '_item';
/** @hidden */
export var COLLAPSE_BUTTON_ID = '_collapsebutton';
/** @hidden */
export var OVRLOF_BUTTON_ID = '_sim_ovrl_overflow';
/** @hidden */
export var GROUPOF_BUTTON_ID = '_sim_grp_overflow';
/** @hidden */
export var HEADER_ID = '_header';
/** @hidden */
export var LAUNCHER_ID = '_launcher';
/** @hidden */
export var CONTENT_ID = '_content';
/** @hidden */
export var CONTAINER_ID = '_container';
/** @hidden */
export var OVERFLOW_ID = '_overflow';
/** @hidden */
export var DROPDOWN_ID = '_dropdown';
/** @hidden */
export var RIBBON_FILE_MENU_ID = '_filemenu';
/** @hidden */
export var RIBBON_BACKSTAGE_MENU_ID = '_backstage';
/** @hidden */
export var RIBBON_BACKSTAGE_POPUP_ID = '_backstagepopup';
/** @hidden */
export var RIBBON_FILE_MENU_LIST = '_filemenulist';
/** @hidden */
export var RIBBON_MENU_LIST = '_menulist';
/** @hidden */
export var RIBBON_FOOTER_MENU_LIST = '_footermenulist';
/** @hidden */
export var RIBBON_HELP_PANE_TEMPLATE_ID = '_helppanetemplate';
/** @hidden */
export var RIBBON_GROUP_BUTTON_ID = '_grpbtn';
/** @hidden */
export var RIBBON_KEYTIP_ID = '_keytip';
/** @hidden */
export var RIBBON_FILE_MENU_WIDTH = '--fileMenuWidth';
/** @hidden */
export var RIBBON_HELP_PANE_TEMPLATE_WIDTH = '--helpTemplateWidth';
